module.exports = __webpack_public_path__ + "img/1.2.c4d66500.png";